import React, {useState, useRef, useEffect} from 'react';
import AddressForm from '../../../SaleJetBlock/Partials/AddressForm/AddressForm';
import {validateInput, TextInputEnum} from '../../../../../utilities/validation/InputValidation';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {connect} from 'react-redux';
import {setDeliveryInfo, setCurrentStep} from '../../TransferOrganizationAccountSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {TransferAccountStep, DWHMessageText, DwhActionType, DWHStatus} from '../../Constant/Constant';
import {dwhGeneralReport} from '../../Reports/dwhReports';

const DeliveryPersonalInfo = (props) => {
  const delivery = props.data.deliveryInfo;
  const [isSubmit, setIsSubmit] = useState(false);
  const [firstName, setFirstName] = useState(delivery.receiverFName);
  const [lastName, setLastName] = useState(delivery.receiverLName);
  const [phone, setPhone] = useState(delivery.receiverPhone);
  const [notes, setNotes] = useState(delivery.notes);
  const [errors, setErrors] = useState({firstName: '', lastName: '', phone: '', address: ''});

  const phoneRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const notesRef = useRef();
  const selectedAddress = {
    cityName: delivery?.city ?? '',
    streetName: delivery?.street ?? '',
    home: delivery?.houseNum ?? '',
    apartment: delivery?.apartment ?? '',
  };

  useEffect(() => {
    dwhGeneralReport({
      data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
      status: DWHStatus.Ongoing,
      messageText: DWHMessageText.DeliveryDetailsSimDisplay,
      actionType: DwhActionType.DeliveryDetailsPageRegularSIM,
    });
  }, []);

  const handleSubmit = (res) => {
    setIsSubmit(false);
    if (res.isValid) {
      var errorFname = validateInput(firstName, TextInputEnum.FirstName);
      var errorLname = validateInput(lastName, TextInputEnum.LastName);
      var errorPhone = validateInput(phone, TextInputEnum.Phone);
      setErrors({...errors, firstName: errorFname, lastName: errorLname, phone: errorPhone});

      if (errorFname == '' && errorLname == '' && errorPhone == '') {
        props.setDeliveryInfo({
          city: res.selectedAddress.cityName,
          street: res.selectedAddress.streetName,
          houseNum: res.selectedAddress.home,
          apartment: res.selectedAddress.apartment,
          receiverFName: firstName,
          receiverLName: lastName,
          receiverPhone: phone,
          notes: notes,
        });
        props.setCurrentStep(TransferAccountStep.DeliveryTimeSlot);
      }
      dwhGeneralReport({
        data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
        status: DWHStatus.Ongoing,
        messageText: DWHMessageText.DeliveryDetailsButtonClicked,
        actionType: DwhActionType.DeliveryDetailsPageRegularSIM,
      });
    }
  };

  return (
    <div className='DeliveryInfo stepContainer'>
      <div className='section'>
        <p className='L_Title'>לאן לשלוח את ה-SIM? </p>
        <AddressForm isSubmit={isSubmit} onSubmit={(res) => handleSubmit(res)} selectedAddress={selectedAddress} />
      </div>
      <div className='section'>
        <p className='M_Title right bold'> למי לתת את המשלוח?</p>
        <TextInput
          value={firstName}
          error={errors.firstName}
          id='firstName'
          placeholder={'שם פרטי'}
          onChange={(e) => {
            setErrors({...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName)});
            setFirstName(e.target.value);
          }}
          ref={firstNameRef}
          required='required'
        />

        <TextInput
          value={lastName}
          error={errors.lastName}
          id='lastName'
          placeholder={'שם משפחה'}
          onChange={(e) => {
            setErrors({...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName)});
            setLastName(e.target.value);
          }}
          ref={lastNameRef}
          required='required'
        />

        <TextInput
          value={phone}
          error={errors.phone}
          id='phone'
          placeholder={'מספר טלפון'}
          onChange={(e) => {
            setErrors({...errors, phone: validateInput(e.target.value, TextInputEnum.Phone)});
            setPhone(e.target.value);
          }}
          required='required'
          ref={phoneRef}
        />
      </div>
      <div className='section'>
        <p className='M_Title right bold'> הערה או בקשה לשליח</p>
        <TextInput
          value={notes}
          error={errors.notes}
          id='notes'
          placeholder={''}
          onChange={(e) => {
            setNotes(e.target.value);
          }}
          maxLength={170}
          ref={notesRef}
        />

        <BtnSubmit text={'לבחירת מועד המשלוח'} onclick={() => setIsSubmit(true)} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setDeliveryInfo,
  setCurrentStep,
};
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryPersonalInfo);
